import { BASE_URL } from '../../../Constant';

export const API_GET_ALL_ARTICLES: string = `${BASE_URL}/article`;
export const API_DELETE_ARTICLE: string = `${BASE_URL}/article`;
export const API_CREATE_ARTICLE: string = `${BASE_URL}/article`;
export const API_UPDATE_ARTICLE: string = `${BASE_URL}/article`;

export const ARTICLE_STATUS_ACTIVE: number = 1;
export const ARTICLE_STATUS_INACTIVE: number = 2;
export const ARTICLE_STATUS_DELETED: number = 10;
